import { render, staticRenderFns } from "./SpeciesNew.vue?vue&type=template&id=56b96134&scoped=true&"
import script from "./SpeciesNew.vue?vue&type=script&lang=js&"
export * from "./SpeciesNew.vue?vue&type=script&lang=js&"
import style0 from "./SpeciesNew.vue?vue&type=style&index=0&id=56b96134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b96134",
  null
  
)

export default component.exports